import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined'
import useStyles from './ChipCheckMark.styles'

type Props = {
    value: boolean
    justifyIcon?: 'flex-start' | 'flex-end' | 'center'
}
const defaultProps: Partial<Props> = {
    justifyIcon: 'center',
}
const ChipCheckMark = ({
    value,
    justifyIcon,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles({
        justifyIcon,
    })

    if (!value) {
        return null
    }

    return (
        <div className={classes.iconWrapper}>
            <CheckCircleOutlined
                className={classes.icon}
            />
        </div>
    )
}

ChipCheckMark.defaultProps = defaultProps

export default ChipCheckMark
